import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
function _window(): any {
  return window;
}
@Injectable({
  providedIn: 'root'
})
export class GlobalServiceService {

  get nativeWindow() : any {
    return _window();
 }
 constructor(private httpClient: HttpClient) {

}
  PostService(url: string, reqObj: any) {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.post(url, reqObj, { headers })
  }

 
getService(url: string, token?: string) {
    const headers = token
      ? new HttpHeaders({ Authorization: `Bearer ${token}` })
      : undefined;

    return this.httpClient.get(url, { headers });
  }


}
